
<app-title-section></app-title-section>

<div class="card p-1"  style="margin-left: 15px; margin-right: 15px; min-height:100vh;">

    <ul class="nav nav-tabs m-0 " style=" border-bottom: 1px solid #eee;" >
        <li class="nav-item">
            <a class="nav-link" [routerLink]="['/tiers/ticketCaisse/tous']" [class.active]="currentStatus === 'tous'" (click)="filterByStatus('tous')">
                Tous <span *ngIf="currentStatus === 'tous'"></span>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [routerLink]="['/tiers/ticketCaisse/disponible']" [class.active]="currentStatus === 'disponible'" (click)="filterByStatus('disponible')">
                Disponible <span *ngIf="currentStatus === 'disponible'"></span>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [routerLink]="['/tiers/ticketCaisse/consolide']" [class.active]="currentStatus === 'consolide'" (click)="filterByStatus('consolide')">
                Consolidé <span *ngIf="currentStatus === 'consolide'"></span>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [routerLink]="['/tiers/ticketCaisse/facture_client']" [class.active]="currentStatus === 'facture_client'" (click)="filterByStatus('facture_client')">
                FacturéClient <span *ngIf="currentStatus === 'facture_client'"></span>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [routerLink]="['/tiers/ticketCaisse/avoire']" [class.active]="currentStatus === 'avoire'" (click)="filterByStatus('avoire')">
                Avoiré <span *ngIf="currentStatus === 'avoire'"></span>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [routerLink]="['/tiers/ticketCaisse/annule']" [class.active]="currentStatus === 'annule'" (click)="filterByStatus('annule')">
                Annulé <span *ngIf="currentStatus === 'annule'">({{ counts['Annulé'] ?? 0 }})</span>
            </a>
        </li>
    </ul>
    <div class="container-fluid" style="padding: 0; width: 100%; max-width: 100%;">
        <router-outlet></router-outlet>
    </div>
</div>


